<div class="contact-actions">
    @if (contact.contactId) { @if (contact.isActive) {
    <por-base-button featureName="contact-deactivate" theme="secondary" (onclick)="onDeactivate()">{{ 'Deactivate' | translate }}</por-base-button>
    } @else {
    <por-base-button featureName="contact-activate" theme="primary" (onclick)="onActivate()">{{ 'Activate' | translate }}</por-base-button>
    } }
</div>
